<template lang="html">
   <div class="test-form">
      <div class="row justify-content-center">
         <div class="col-12 col-md-10 col-lg-9 col-xl-8">
            <Form 
               classBinding="row" 
               :ref="Transaction.forms.queryID.name" 
               :forms="Transaction.forms.queryID.forms" 
               :form_data="Transaction.forms.queryID.data"
            />
         </div>
         <div class="col-12 col-md-5 col-lg-3 col-xl-4">
            <div class="btn btn-primary btn-padded" :disabled="loading" @click="queryTransactionsByID({ref: $refs[Transaction.forms.queryID.name]})">
               Query
               <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
            </div>
         </div>
      </div>

      <Table 
         :icon="Transaction.tables.transactions.icon" 
         :table_fields="Transaction.tables.transactions.table_fields" 
         :table_data="idTransactions" 
         :title="Transaction.tables.transactions.title" 
         :search_fields="Transaction.tables.transactions.search_fields"
         :row_data="Transaction.tables.transactions.row_data"
         @on-action="handleActions"
      />
   </div>
</template>

<script>
import transaction from "../rsc/stores/transactions/transaction.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('transaction')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('transaction',transaction,this.$store)

      setTimeout(() => {
         EventBus.$emit('actions:register',{
            title: '',
            actions: []
         })
      },200);
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'Transaction',
         'idTransactions',
         'show',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
         'queryTransactionsByID',
      ]),
      handleActions(){

      }
   },
   async mounted(){
      utils.registerModule('transaction',transaction,this.$store)
      EventBus.$emit('loader:show', false)
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>